import { NavLink, useNavigate } from 'react-router-dom';
import { Plus, List, LogOut } from 'lucide-react';
import '../styles/components/sidebar.css';

export default function Sidebar({ open, onClose }) {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const handleNav = () => {
    if (onClose) onClose();
  };

  return (
    <nav className={`sidebar${open ? ' open' : ''}`}>
      <div className="sidebar-logo">
        <h1>AgeEstimator</h1>
        <span>Discovery & Age Estimation</span>
      </div>

      <div className="nav-section">
        <div className="nav-section-label">Jobs</div>
        <NavLink to="/" end className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={handleNav}>
          <Plus size={18} />
          New Job
        </NavLink>
        <NavLink to="/jobs" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={handleNav}>
          <List size={18} />
          Job History
        </NavLink>
      </div>

      <div style={{ marginTop: 'auto', padding: '16px 0', borderTop: '1px solid var(--border)' }}>
        <button className="nav-item sidebar-logout" onClick={logout}>
          <LogOut size={18} />
          Logout
        </button>
      </div>
    </nav>
  );
}
